import { useQuery } from '@tanstack/react-query';

import { freePassQueries } from '../api/freePassQueries';
import { selectActivePromo } from '../helpers/promoHelpers';
import useFreePassEnabled from './useFreePassEnabled';
import useFreePassUserId from './useFreePassUserId';

const useActivePromoQuery = () => {
  const enabled = useFreePassEnabled();
  const userId = useFreePassUserId();

  // No user-id guard: `GET /promos/actual` answers anonymously, which is how a
  // guest gets the promo's real name and day count. The id still keys the cache
  // so a guest and a user can never read each other's entry.
  return useQuery({
    ...freePassQueries.promos(userId),
    select: selectActivePromo,
    enabled,
  });
};

export default useActivePromoQuery;
